<template>
  <div>
    <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('listTitle') }}</div>
    <div v-if="list.length > 0"
         :class="{'divide-y divide-border':!currentUserIsWatcher}">
      <TagListItem v-for="item in list" :key="item.id"
                   :tag="item"
                   :allow-actions="!currentUserIsWatcher"/>
    </div>
    <div v-else class="text-md pl-2 text-text">
      {{ $t('noTags') }}
    </div>
  </div>
</template>

<script>
import IconEdit from "@/components/icons/IconEdit";
import {mapGetters} from "vuex";
import IconTrash from "@/components/icons/IconTrash";
import TagListItem from "@/components/cabinet/SpaceSettings/TagsSettings/TagListItem";

export default {
  name: "TagsList",
  components: {TagListItem, IconTrash, IconEdit},
  props: {
    list: {
      type: Array
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
  },
  i18n: {
    messages: {
      en: {
        listTitle: 'Tags list',
        noTags: 'List is empty'
      },
      ru: {
        listTitle: 'Список тегов',
        noTags: 'Список пуст'
      }
    }
  }
}
</script>
